/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Handynummerchancenwerk1Inputs */

const de__field_handynummerchancenwerk1 = /** @type {(inputs: _Field_Handynummerchancenwerk1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handynummer Chancenwerk`)
};

/**

* @param {_Field_Handynummerchancenwerk1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_handynummerchancenwerk1 = /** @type {((inputs?: _Field_Handynummerchancenwerk1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Handynummerchancenwerk1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_handynummerchancenwerk1(inputs)
});
export { _field_handynummerchancenwerk1 as "_field_handynummerChancenwerk" }